import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

const workingContext = $(".lc-main-workingContext");
const workingContextPopover = $(".lc-working-context-popover");

register.registerKnockoutBinding("workingContextPopover", {
    init: function () {
        $("body").on("click", function (e) {
            const target = $(e.target);

            if (
                !target.parents(".lc-main-workingContext").is(workingContext) &&
                !target.parents(".lc-working-context-popover").is(workingContextPopover)
            ) {
                const vm = ko.dataFor($("body")[0]);
                vm.workingContext.isExpanded(false);
            }
        });
    },
    update: function (_element, valueAccessor, _allBindingsAccessor, viewModel) {
        if (!valueAccessor()() || viewModel.workingContext.hasExpander() === false) {
            workingContext.removeClass("active");
            workingContextPopover.removeClass("show");
        } else {
            const workingContextWidth = workingContext.outerWidth();

            const workingContextPos = $(".lc-working-context-expander").position();
            workingContextPopover.css("top", workingContextPos.top + 35);
            workingContextPopover.css("min-width", workingContextWidth);

            const leftPos = workingContext.position().left;

            workingContextPopover.css("left", leftPos);

            workingContext.toggleClass("active");
            workingContextPopover.toggleClass("show");
        }
    }
});
